import apiClient from './apiClient';
import { API_ENDPOINTS } from '../utils/constants';

export const userApi = {
  searchOpenUsers: async (businessNetworkID) => {
    try {
      const response = await apiClient.post(API_ENDPOINTS.SEARCH_OPEN_USERS, {
        BusinessNetworkID: businessNetworkID
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },

  // New method to find a specific user by searching across networks
  findUserById: async (userId, preferredNetworkId = 1) => {
    try {
      // First try the preferred network
      let response = await apiClient.post(API_ENDPOINTS.SEARCH_OPEN_USERS, {
        BusinessNetworkID: preferredNetworkId
      });

      let foundUser = response.data.result?.find(u =>
        u.createdByWalletUserRegistrationID === parseInt(userId)
      );

      if (foundUser) {
        return { user: foundUser, networkId: preferredNetworkId };
      }

      // If not found in preferred network, try other common networks
      const networksToTry = [1, 2, 3, 4, 5]; // Common network IDs

      for (const networkId of networksToTry) {
        if (networkId === preferredNetworkId) continue; // Skip already tried

        try {
          response = await apiClient.post(API_ENDPOINTS.SEARCH_OPEN_USERS, {
            BusinessNetworkID: networkId
          });

          foundUser = response.data.result?.find(u =>
            u.createdByWalletUserRegistrationID === parseInt(userId)
          );

          if (foundUser) {
            return { user: foundUser, networkId: networkId };
          }
        } catch (error) {
          // Continue to next network if this one fails
          console.warn(`Failed to search network ${networkId}:`, error);
        }
      }

      return { user: null, networkId: null };
    } catch (error) {
      console.error('Error finding user by ID:', error);
      throw error;
    }
  },

  getRecentUsers: async (count = 5) => {
    try {
      const response = await apiClient.post(API_ENDPOINTS.SEARCH_OPEN_USERS, {
        BusinessNetworkID: 1
      });
      const users = response.data.result || [];
      return users.slice(0, count);
    } catch (error) {
      console.error('Error fetching recent users:', error);
      throw error;
    }
  },

  searchOpenUsersFull: async (businessNetworkID) => {
    try {
      const response = await apiClient.post('/api/v1/WebUser/SearchOpenUsersFull', {
        BusinessNetworkID: businessNetworkID
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching full user details:', error);
      throw error;
    }
  },

  // Find a specific user with full details (including listings) by searching across networks
  findUserByIdFull: async (userId, preferredNetworkId = 1) => {
    try {
      console.log('Searching for user:', userId, 'with preferred network:', preferredNetworkId);

      // If preferredNetworkId is 0, search globally across all networks
      if (preferredNetworkId === 0) {
        console.log('Using BusinessNetworkId=0 for global search');
        const response = await apiClient.post('/api/v1/WebUser/SearchOpenUsersFull', {
          BusinessNetworkID: 0,
          WalletUserRegistrationID: parseInt(userId)
        });

        const foundUser = response.data.result?.find(u =>
          u.createdByWalletUserRegistrationID === parseInt(userId)
        );

        if (foundUser) {
          return { user: foundUser, networkId: 0 };
        }

        return { user: null, networkId: null };
      }

      // First try the preferred network with full details
      let response = await apiClient.post('/api/v1/WebUser/SearchOpenUsersFull', {
        BusinessNetworkID: preferredNetworkId
      });

      let foundUser = response.data.result?.find(u =>
        u.createdByWalletUserRegistrationID === parseInt(userId)
      );

      if (foundUser) {
        return { user: foundUser, networkId: preferredNetworkId };
      }

      // If not found in preferred network, try other common networks with full details
      const networksToTry = [1, 2, 3, 4, 5]; // Common network IDs

      for (const networkId of networksToTry) {
        if (networkId === preferredNetworkId) continue; // Skip already tried

        try {
          response = await apiClient.post('/api/v1/WebUser/SearchOpenUsersFull', {
            BusinessNetworkID: networkId
          });

          foundUser = response.data.result?.find(u =>
            u.createdByWalletUserRegistrationID === parseInt(userId)
          );

          if (foundUser) {
            return { user: foundUser, networkId: networkId };
          }
        } catch (error) {
          // Continue to next network if this one fails
          console.warn(`Failed to search network ${networkId}:`, error);
        }
      }

      return { user: null, networkId: null };
    } catch (error) {
      console.error('Error finding user by ID with full details:', error);
      throw error;
    }
  },

  // Find a specific user by code using RootIdentityUrl property
  findUserByCodeFull: async (userCode) => {
    try {
      console.log('Searching for user by code:', userCode);

      // Search globally with BusinessNetworkId=0 and RootIdentityUrl
      const response = await apiClient.post('/api/v1/WebUser/SearchOpenUsersFull', {
        BusinessNetworkID: 0,
        RootIdentityUrl: userCode
      });

      console.log('User search response:', response.data);

      // Find user matching the code in RootIdentityUrl
      const foundUser = response.data.result?.find(u => {
        // Check if RootIdentityUrl matches the provided code
        const rootIdentityUrl = u.rootIdentityUrl || u.RootIdentityUrl || '';
        return rootIdentityUrl.toLowerCase().includes(userCode.toLowerCase()) ||
               rootIdentityUrl === userCode;
      });

      if (foundUser) {
        console.log('Found user by code:', foundUser);
        return { user: foundUser, networkId: 0 };
      }

      console.log('No user found with code:', userCode);
      return { user: null, networkId: null };
    } catch (error) {
      console.error('Error finding user by code:', error);
      throw error;
    }
  }
};
